import parseIntOrFloat from "./parseIntOrFloat"

/**
 * Sanitizes a given input to a number.
 * If the input is undefined/null, not a string/number, or cannot be parsed to a number, it throws an error.
 * @param value The value to be sanitized.
 * @returns The sanitized number.
 * @throws If the input is invalid, or if unable to parse to a number.
 */
export function sanitizeNumber(value: any): number {
  if (value === undefined || value === null) throw new Error("Invalid input")
  if (typeof value !== 'string' && typeof value !== 'number') throw new Error("Invalid input")
  const parsedValue = parseIntOrFloat(value)
  if (!parsedValue && parsedValue !== 0) throw new Error("Unable to parse number")
  return parsedValue
}
